import { IConfig, IPage } from 'utils/types';

export function createOptionFromPage(page: IPage, { isAgent }: IConfig = {}) {
  return {
    value: page.id,
    label: page.name,
    optionActionAvailable: page.currentStep === 'page',
    name: page.name,
    handle: page.handle,
    id: page.id,
    showContentIndicator: isAgent && (page.systemWide || page?.shared),
    shared: page?.shared,
    subtitle: page?.tags?.length > 0 ? `Tags: ${page.tags.slice(0, 3).join(', ')}` : '',
  };
}

export const createOptionFromPageV2 = (page: IPage, { isAgent }: IConfig = {}) => {
  return {
    value: page.id,
    label: page.name,
    name: page.name,
    id: page.id,
    showContentIndicator: isAgent && (page.systemWide || page?.shared),
    shared: page?.shared,
    subtitle: page?.tags.length > 0 ? `Tags: ${page?.tags.slice(0, 3).join(', ')}` : '',
  };
};
